import { createSharedComposable, useColorMode, useToggle, useMagicKeys } from '@vueuse/core';
import { computed } from 'vue-demi';
import Cookies from 'universal-cookie';

class CookiesStorageLike {
  constructor(config) {
    this.config = config;
    this.cookie = new Cookies();
    this.cookieDomain = config.COOKIE_DOMAIN;
    this.cookieName = `${config.COOKIE_NAME_PREFIX}_dark_mode`;
  }

  getItem(key) {
    return this.cookie.get(this.cookieName) === '1' ? 'dark' : 'light';
  }

  removeItem(key) {
    this.cookie.remove(this.cookieName);
  }

  setItem(key, value) {
    this.cookie.set(this.cookieName, value === 'dark' ? '1' : '0', {
      path: '/',
      domain: this.cookieDomain,
      //set expiration time like current time + 1 year
      expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1))
    });
  }

}

function listenCookieChange(cookieItemKey, callback) {
  const getCookieValue = () => {
    var _a;

    return (_a = document.cookie.split('; ').find(row => row.startsWith(`${cookieItemKey}=`))) === null || _a === void 0 ? void 0 : _a.split('=')[1];
  };

  let lastCookieValue = getCookieValue();

  const raf = () => window.requestAnimationFrame(() => {
    const newCookieValue = getCookieValue();

    if (lastCookieValue !== newCookieValue) {
      try {
        callback({
          oldVal: lastCookieValue,
          newVal: newCookieValue
        });
      } finally {
        lastCookieValue = newCookieValue;
      }
    }

    raf();
  });

  raf();
}

function useDarkMode(config) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let darkModeChange; //some default values

  const {
    valueLight = 'light',
    valueDark = 'dark',
    selector = 'html',
    storage = new CookiesStorageLike(config),
    ...rest
  } = options;
  const mode = useColorMode({ ...rest,
    storage,
    modes: {
      dark: valueDark,
      light: valueLight
    },
    selector
  });
  const isDark = computed({
    get() {
      return mode.value === 'dark';
    },

    set(v) {
      mode.value = v ? 'dark' : 'light';
    }

  });
  const toggleDark = useToggle(isDark);
  const cookieName = `${config.COOKIE_NAME_PREFIX}_dark_mode`;
  listenCookieChange(cookieName, _ref => {
    let {
      newVal
    } = _ref;
    return toggleDark(!!Number(newVal));
  });

  const addChangeListener = callback => {
    darkModeChange = callback;
  };

  useMagicKeys({
    passive: false,
    onEventFired: e => {
      if ((navigator.platform === 'MacIntel' ? e.metaKey : e.ctrlKey) && e.shiftKey && e.key.toLowerCase() === 'd' && e.type === 'keydown') {
        e.preventDefault();
        toggleDark();
        darkModeChange === null || darkModeChange === void 0 ? void 0 : darkModeChange(isDark.value);
      }
    }
  });
  return {
    isDark,
    toggleDark,
    addChangeListener
  };
}

var useDarkMode$1 = createSharedComposable(useDarkMode);

export { useDarkMode$1 as u };
